import {MESSAGE_WEB_SOCKET} from "../../helper/host";

export const CreateWebSocket = (path, token, params) => {
    const baseUrlWs = MESSAGE_WEB_SOCKET;

    const cleanPatch = path.replace(/^\+|\/+$/g, '');

    const url = new URL(`${baseUrlWs.replace(/\/$/, '')}/${cleanPatch}`);


    url.searchParams.append('token', token);

    if (params){
        const searchParams = new URLSearchParams(params);
        for(const [key, value] of searchParams){
            url.searchParams.append(key, value);
        }
    }

    return Promise.resolve(url.toString().replace(/\/\?/, '?'));
}